import api from "api";
import { IAddLaundryHolidayBody, IAddAdminLaundryHolidayBody, IGetAdminLaundryHolidaysQueryParams, IEditLaundryHolidayBody, IGetLaundryHolidaysQueryParams, IApproveRejectLaundryUpdatesBody, IGetLaundriesQueryParams, IChangeLaundryScheduleIntervalBody, IChangeLaundryCommissionBody, IChangeLaundryCancelCommissionsBody, IGetLaundryBranchesQueryParams } from "types/laundry";

import { convertObjToQuery } from "utils/convertObjToQuery";

const getLaundry = (carWashId?: number) => {
  let query = ""

  if (carWashId !== undefined) {
    query = `carWashId=${carWashId}`
  }

  return api.get(`/carWash/getCarWashData?${query}`)
}

const getLaundries = ({ search, sortBy, pageIndex, pageSize, isOpen }: IGetLaundriesQueryParams) => {

  let query = `sortBy=${sortBy}&pageSize=${pageSize}&pageIndex=${pageIndex}`

  if (search) {
    query += `&search=${search}`
  }

  if (isOpen !== null) {
    query += `&isOpen=${isOpen}`
  }

  return api.get(`/carWash/GetCarWashList?${query}`)
}

const getLaundryBranches = ({ pageSize, pageIndex, sortBy, sortOrder, search }: IGetLaundryBranchesQueryParams) => {
  let query = `?pageSize=${pageSize}&pageIndex=${pageIndex}`

  if (search !== undefined) {
    query += `&search=${search}`
  }

  return api.get(`/carWash/getCarWashDropdownData${query}`)

}

const getLaundryDistricts = () =>
  api.get("/carWash/getDistricts")

const getLaundryChangesHistory = (laundryId: number) =>
  api.get(`/carWash/GetCarWashChangeRequestInfo/${laundryId}`)

const getLaundryScheduleInterval = (laundryId: number | null) =>
  api.get(`/carWash/getCarWashScheduleInterval/${laundryId}`)

const getLaundryCommission = (laundryId: number | null) =>
  api.get(`/carWash/getCarWashCommission/${laundryId}`)

const getLaundryCancelCommissions = (laundryIds: number[]) => {

  let query = ""

  laundryIds.forEach((laundryId: number, index: number) => {
    query += `carWashIds[${index}]=${laundryId}&`
  })

  return api.get(`/carWash/GetCarWashCancelCommissions?${query}`)
}

const createOrUpdateLaundry = (formData: any) =>
  api.post("/carWash/createOrUpdateCarWash", formData, { headers: { "Content-Type": "multipart/form-data" } })

const deleteLaundry = (laundryId: number) =>
  api.delete(`/carWash/deleteCarWash/${laundryId}`)

const approveRejectLaundryUpdates = (data: IApproveRejectLaundryUpdatesBody) =>
  api.post("/carWash/approveRejectCarWashChangeRequestInfo", data)

const changeLaundryScheduleInterval = (data: IChangeLaundryScheduleIntervalBody) =>
  api.post("/carWash/changeCarWashScheduleInterval", data)

const changeLaundryCommission = (data: IChangeLaundryCommissionBody | null) =>
  api.post("/carWash/changeCarWashCommission", data)

const changeLaundryCancelCommissions = (data: IChangeLaundryCancelCommissionsBody) =>
  api.post("/carWash/ChangeCarWashCancelCommission", data)

const getLaundryHolidays = (query: IGetLaundryHolidaysQueryParams) => 
  api.get(`/carWash/getHolidays?${convertObjToQuery<IGetLaundryHolidaysQueryParams>(query)}`)

const addLaundryHoliday = (data: IAddLaundryHolidayBody) =>
  api.post("/carWash/addHoliday", data)

const getAdminLaundryHolidays = (params: IGetAdminLaundryHolidaysQueryParams) => {

  const { sortBy, pageSize, pageIndex, carWashIds } = params

  let query = `sortBy=${sortBy}&pageSize=${pageSize}&pageIndex=${pageIndex}`

  
    carWashIds.forEach(( id: number) => {
      query += `&carWashIds=${id}`
    })

    return api.get(`/carWash/getAdminHolidays?${query}`)

}

const addAdminLaundryHolidays = (data: IAddAdminLaundryHolidayBody) =>
  api.post("/carWash/addAdminHolidayes", data)

const updateLaundryHoliday = (data: IEditLaundryHolidayBody) =>
  api.put("/carWash/updateHoliday", data)

const deleteLaundryHoliday = (id: number) =>
  api.delete(`/carWash/deleteHoliday/${id}`)

const getLaundryWithChangesCount = () =>
  api.get("/carWash/GetCarWashWithChangesCount")

export default {
  getLaundry,
  getLaundries,
  deleteLaundry,
  getLaundryBranches,
  getLaundryDistricts,
  getLaundryChangesHistory,
  getLaundryScheduleInterval,
  getLaundryCommission,
  getLaundryCancelCommissions,
  approveRejectLaundryUpdates,
  changeLaundryScheduleInterval,
  changeLaundryCommission,
  changeLaundryCancelCommissions,
  createOrUpdateLaundry,
  getLaundryHolidays,
  addLaundryHoliday,
  getAdminLaundryHolidays,
  addAdminLaundryHolidays,
  deleteLaundryHoliday,
  updateLaundryHoliday,
  getLaundryWithChangesCount
}